/* Fine Foams cart drawer: "Complete the set" upsell add. Re-renders the drawer
   via Dawn's Section Rendering flow so the upsell list stays accurate. */
(function () {
  if (window.ffCartUpsellAdd) return;
  window.ffCartUpsellAdd = function (btn) {
    var id = parseInt(btn.getAttribute('data-ff-upsell-add'), 10);
    if (!id || btn.disabled) return;
    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: id, quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw res;
        if (drawer && drawer.renderContents) drawer.renderContents(res);
      })
      .catch(function () { window.location.href = window.Shopify.routes.root + 'cart'; })
      .finally(function () { btn.disabled = false; });
  };
})();
